import { CrudCollectionPage } from "./CrudCollectionPage";
import { hasPermission } from "../core/session";

export function FtoReportsPage() {
  return (
    <CrudCollectionPage
      label="FTO Reports"
      singular="FTO Report"
      endpoint="/fto-reports"
      icon="nav_legislation"
      canDelete={hasPermission("fto-reports.delete")}
      advancedFields={[
        { key: "createdBy", label: "Creator User ID", type: "number" },
        { key: "createdFor", label: "Cadet User ID", type: "number" },
        { key: "createdFrom", label: "Date From", type: "datetime-local" },
        { key: "createdTo", label: "Date To", type: "datetime-local" },
      ]}
      createDefaults={{
        createdFor: null,
        title: "",
        description: "",
        pursuits: "-1",
        radio: "-1",
        caselaw: "-1",
        traffic: "-1",
        reports: "-1",
        professionalism: "-1",
        sops: "-1",
        processing: "-1",
      }}
      fields={[
        { key: "createdFor", label: "Trainee User ID", type: "number" },
        { key: "createdForFirstName", label: "First Name", readOnly: true },
        { key: "createdForLastName", label: "Last Name", readOnly: true },
        { key: "title", label: "Title" },
        { key: "description", label: "Description" },
        { key: "pursuits", label: "Pursuits" },
        { key: "radio", label: "Radio" },
        { key: "caselaw", label: "Case Law" },
        { key: "traffic", label: "Traffic Stops" },
        { key: "reports", label: "Reports" },
        { key: "professionalism", label: "Professionalism" },
        { key: "sops", label: "SOPs" },
        { key: "processing", label: "Processing" },
      ]}
      itemTitle={(item) =>
        `${value(item.createdForFirstName)} ${value(item.createdForLastName)} - ${value(item.title)}`
      }
      itemRightLabel={(item) =>
        `${value(item.createdByFirstName)} ${value(item.createdByLastName)} - ${date(item.createdAt)}`
      }
      detailEndpoint={(item) =>
        `/fto-reports/${String(item.createdFor)}/${String(item.id)}`
      }
      createEndpoint={(item) =>
        `/fto-reports/${String(item.createdFor)}`
      }
      updateEndpoint={(item) =>
        `/fto-reports/${String(item.createdFor)}/${String(item.id)}`
      }
      deleteEndpoint={(item) =>
        `/fto-reports/${String(item.createdFor)}/${String(item.id)}`
      }
      prepareWrite={(item, creating) => ({
        ...(creating ? {} : { createdFor: Number(item.createdFor) }),
        title: value(item.title),
        description: value(item.description),
        pursuits: value(item.pursuits),
        radio: value(item.radio),
        caselaw: value(item.caselaw),
        traffic: value(item.traffic),
        reports: value(item.reports),
        professionalism: value(item.professionalism),
        sops: value(item.sops),
        processing: value(item.processing),
      })}
    />
  );
}

function value(input: unknown): string {
  return typeof input === "string" || typeof input === "number"
    ? String(input)
    : "";
}
function date(input: unknown): string {
  const valueString = value(input);
  return valueString ? new Date(valueString).toLocaleString() : "";
}
